import api from '../api/api';

// Get school exams for grade details sender
export const getSchoolExams = async () => {
  const response = await api.get('/communications/school/exams');
  return response.data;
};

// Get students with their exam performance data
export const getExamStudents = async (examId: number) => {
  const response = await api.get(`/communications/school/exam/${examId}/students`);
  return response.data;
};

// Send grade details to parents
export const sendGradeDetails = async (requestData: any) => {
  const response = await api.post('/communications/school/send-grades', requestData);
  return response.data;
}; 